import React, { useCallback, useState, useMemo } from "react";
import RightSideNav from "../components/sidenav/RightSideNav";
import { useDispatch } from "react-redux";
import { removeAlarm, clearInactiveAlarms } from "../ducks/alarmsDuck";
import { sendCommand } from "../ducks/uiDuck";
import {
  useAlarmCounts,
  useAlarmsByCategory,
  useSystemId,
  useUIState,
  useServiceMode,
  useSystemConfig,
} from "../hooks/useReduxSelectors";

const RIGHT_MENU = {
  defaultSelected: "",
  menuList: [
    { label: "Alarms", hasSubNav: true, isActiveAlarms: false, isActiveWarnings: false, isCategory: true, disabled: true },
    { label: "Devices", hasSubNav: false, counts: 0 },
    { label: "Samples", hasSubNav: false, counts: 0 },
    { label: "Warnings", hasSubNav: false, counts: 0 },
  ],
};

const AlarmsSideBarContainer = ({ isCompact, isMobile, containerRef, rightDrawerOpen, onCloseRightDrawer }) => {
  const systemId = useSystemId();
  const dispatch = useDispatch();
  const config = useSystemConfig();
  const ui = useUIState();
  const serviceMode = useServiceMode();
  const serviceModeActive = ui?.serviceMode?.isActive;
  const isManualMode = serviceMode?.status === "ManualActive";

  const [selectedType, setSelectedType] = useState("");

  // All alarm data comes from Redux (single source of truth)
  const alarmCounts = useAlarmCounts();
  const categoryAlarms = useAlarmsByCategory(selectedType);

  // Build menu items from memoized alarm counts
  const menuItems = useMemo(() => {
    const { devices, samples, warnings } = alarmCounts;
    return {
      defaultSelected: RIGHT_MENU.defaultSelected,
      menuList: [
        {
          ...RIGHT_MENU.menuList[0],
          isActiveAlarms: devices > 0 || samples > 0,
          isActiveWarnings: warnings > 0,
        },
        {
          ...RIGHT_MENU.menuList[1],
          hasSubNav: devices > 0,
          counts: devices,
        },
        {
          ...RIGHT_MENU.menuList[2],
          hasSubNav: samples > 0,
          counts: samples,
        },
        {
          ...RIGHT_MENU.menuList[3],
          hasSubNav: warnings > 0,
          counts: warnings,
        },
      ],
    };
  }, [alarmCounts]);

  const onGetAlarmsByCategory = useCallback((selectedItem) => {
    setSelectedType(selectedItem);
  }, []);

  const onDeleteAlarms = useCallback((alarmItem, e) => {
    e.stopPropagation();
    if (alarmItem) {
      if (!alarmItem.isActive) {
        dispatch(removeAlarm({ alarmId: alarmItem.alarmId, hwId: alarmItem.hwId, systemId }));
      }
    } else {
      // Clear all inactive alarms
      dispatch(clearInactiveAlarms({ systemId }));
    }
  }, [dispatch, systemId]);

  const handleAutoManualToggle = useCallback(() => {
    const isManual = serviceMode?.status === "ManualActive";
    dispatch(
      sendCommand({
        argsProps: {
          HwId: "EdgeDevice",
          customerId: config?.CUSTOMER_ID || "",
          deviceId: config?.DEVICE_ID || "",
          Command: "ManualMode",
          Value: isManual ? "Off" : "On",
        },
        commandType: isManual ? "Manual" : "Auto",
        systemId,
      })
    );
  }, [dispatch, serviceMode, config, systemId]);

  return (
    <RightSideNav
      menuitems={menuItems}
      categoryAlarms={categoryAlarms}
      onDeleteAlarms={onDeleteAlarms}
      onGetAlarmsByCategory={onGetAlarmsByCategory}
      isCompact={isCompact}
      isMobile={isMobile}
      containerRef={containerRef}
      rightDrawerOpen={rightDrawerOpen}
      onCloseRightDrawer={onCloseRightDrawer}
      serviceModeActive={serviceModeActive}
      isManualMode={isManualMode}
      onAutoManualToggle={handleAutoManualToggle}
    />
  );
};

export default AlarmsSideBarContainer;
